<template>
    <div class="page-customer page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">维修项目管理</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>维修项目管理</el-breadcrumb-item>
                            <el-breadcrumb-item>维修项目列表</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
				
				<el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
				    <el-button type="primary" class="btn-bg-p" @click="handleTask('add')">添加 <i class="el-icon-plus"></i></el-button>
				</el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                          
						 <el-form-item prop="projectName" label="项目名称：">
							 <el-select size="small" v-model="form_search.projectId" placeholder="请选择" style="width:100%;">
								 <el-option
										 v-for="item in init_data.projectList"
										 :key="item.icode"
										 :label="item.projectName"
										 :value="item.icode">
								 </el-option>
							 </el-select>
						 </el-form-item>
						 <el-form-item prop="workerName" label="施工人员姓名：" style="margin-bottom: 0;">
						      <el-input v-model="form_search.workerName" size="small" placeholder="施工人员姓名" clearable></el-input>
						  </el-form-item>
						  <el-form-item prop="location" label="地址：" style="margin-bottom: 0;">
						       <el-input v-model="form_search.location" size="small" placeholder="地址" clearable></el-input>
						   </el-form-item>
						   <el-form-item label="日期：">
						   	<el-date-picker size="small" clearable v-model="create_range" type="daterange"
						   		range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
						   		value-format="yyyy-MM-dd">
						   	</el-date-picker>
						   </el-form-item>
						 <!-- <el-form-item prop="status" label="项目状态：">
							<el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
								<el-option
										v-for="item in init_data.status_list"
										:key="item.id"
										:label="item.name"
										:value="item.id">
								</el-option>
							</el-select>
						</el-form-item> -->
						
                     
                       <el-form-item style="margin-bottom: 0;">
                           <el-button type="primary" class="search-btn"  size="medium" @click='exreport()'>导出表格</el-button>
                       </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
                            <!-- <el-table-column prop="icode" width="80" label="icode" align="center"></el-table-column> -->
                            <el-table-column prop="projectName" align="center" label="项目名称" min-width="140">
                            </el-table-column>
							<el-table-column prop="workDays" align="center" label="施工天数" min-width="120">
							</el-table-column>
							<el-table-column prop="location" align="center" label="地址" min-width="120">
							</el-table-column>
							<el-table-column prop="workerName" align="center" label="施工人员" min-width="120">
							</el-table-column>
							
                            <el-table-column prop="workerCount" align="center" label="施工人数" min-width="120">
                            </el-table-column>
							<el-table-column prop="constructionDate" align="center" label="施工时间" min-width="160">
							</el-table-column>
                            <el-table-column prop="otherCost" align="center" label="其他费用" min-width="120">
                            </el-table-column>
							<el-table-column prop="fuelCost" align="center" label="加油费" min-width="120">
							</el-table-column>
                           
                            <el-table-column prop="operating" align="center" label="操作" min-width="100" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleTask('edit',scope.row)">编辑</el-button>							
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteTask(scope.row.icode)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.pageNo"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
		<el-dialog class="dialog-export goods-dialog" :title="dlg_fix.title" :visible.sync="dlg_fix.visible" width="600px" @closed="closeGoods" :close-on-click-modal="false">
		    <el-form ref="formOrder" :model="dlg_fix.form" label-width="160px" :rules="dlg_fix.rules" @submit.native.prevent>
		        <el-row style="margin-top: 15px;" :gutter="20">
		            <el-col :span="24">
		                <el-form-item prop="projectName" label="维修项目名称：" :error="dlg_fix.error.projectName">
		                   <el-select size="small" v-model="dlg_fix.form.projectName" placeholder="请选择" style="width:100%;" >
							 <el-option
									 v-for="item in init_data.projectList"
									 :key="item.icode"
									 :label="item.projectName"
									 :value="item.icode"
									 @click.native="getCorpAndDept(item)">
							 </el-option>
						 </el-select>
		                </el-form-item>
		            </el-col>
				</el-row>
				<el-row style="margin-top: 15px;" :gutter="20">
				    <el-col :span="24">
				        <el-form-item prop="workDays" label="施工天数(单位/天)：" :error="dlg_fix.error.workDays">
				            <el-input size="small" v-model="dlg_fix.form.workDays" placeholder='请输入施工天数(天)' clearable></el-input>
				        </el-form-item>
				    </el-col>
				</el-row>
				<el-row style="margin-top: 15px;" :gutter="20">
				    <el-col :span="24">
				        <el-form-item prop="workerName" label="施工人员姓名：" :error="dlg_fix.error.workerName">
				            <el-input size="small" v-model="dlg_fix.form.workerName" placeholder='施工人员姓名' clearable></el-input>
				        </el-form-item>
				    </el-col>
				</el-row>
				<el-row style="margin-top: 15px;" :gutter="20">
				    <el-col :span="24">
				        <el-form-item label="施工人数：" :error="dlg_fix.error.workerCount">
				            <el-input size="small" v-model="dlg_fix.form.workerCount" placeholder='施工人数' clearable></el-input>
				        </el-form-item>
				    </el-col>
				</el-row>
				<el-row style="margin-top: 15px;" :gutter="20">
				    <el-col :span="24">
				        <el-form-item prop="location" label="维修项目地址：" :error="dlg_fix.error.location">
				            <el-input size="small" v-model="dlg_fix.form.location" placeholder='请输入维修项目地址' clearable></el-input>
				        </el-form-item>
				    </el-col>
				</el-row>
				<el-row style="margin-top: 15px;" :gutter="20">
				    <el-col :span="24">
						<el-form-item label="施工日期：" prop="constructionDate" :error="dlg_fix.error.constructionDate">
								<el-date-picker
									v-model="dlg_fix.form.constructionDate"
									type="date"
									format="yyyy-MM-dd"
									value-format="yyyy-MM-dd"
									placeholder="施工日期"
								/>
								
						</el-form-item>
				     
				    </el-col>
				</el-row>
				<el-row style="margin-top: 15px;" :gutter="20">
				    <el-col :span="24">
				        <el-form-item  label="其他费用：" >
				            <el-input size="small" v-model="dlg_fix.form.otherCost" placeholder='其他费用' clearable></el-input>
				        </el-form-item>
				    </el-col>
				</el-row>
				<el-row style="margin-top: 15px;" :gutter="20">
				    <el-col :span="24">
				        <el-form-item  label="加油费：" >
				            <el-input size="small" v-model="dlg_fix.form.fuelCost" placeholder='加油费' clearable></el-input>
				        </el-form-item>
				    </el-col>
				</el-row>
				<el-row style="margin-top: 15px;" :gutter="20">
				    <el-col :span="24">
				        <el-form-item  label="备注：" >
				            <el-input size="small" v-model="dlg_fix.form.description" placeholder='备注' clearable></el-input>
				        </el-form-item>
				    </el-col>
				</el-row>
		       
				<el-row :gutter="20">
				    <el-col :span="24">
						<el-form-item  style="margin-top: 15px;" label="完成照片：" :error="dlg_fix.error.imageIds">
						    <el-upload
						            :action="$client.API_URL+'/api/sys/file/upload'"
						            :headers="fixList.params.headers"
						            accept=""
									:limit="1"
						            :class="fixList.hide_upload?'hide-upload head-upload':'head-upload'"
						            list-type="picture-card"
						            :file-list="fixList.img_list"
						            name="file"
									:on-preview="(file) => {dlg_preview.img_url = file.url;dlg_preview.visible = true;}"
									:on-remove="removePic"
									 :on-success="uploadSuccessPic"
						           >
						        <i class="el-icon-plus"></i>
						    </el-upload>
						</el-form-item>
				       
				    </el-col>
				</el-row>
				<el-row :gutter="20">
				    <el-col :span="24">
						<el-form-item prop="fileId" style="margin-top: 15px;" label="完成视频：" :error="dlg_fix.error.videos">
						    <el-upload
						            :action="$client.API_URL+'/api/sys/file/upload'"
						            :headers="fixList.params.headers"
						            accept=""
									:limit="1"
						            :class="fixList.hide_uploadV?'hide-upload head-upload':'head-upload'"
						            list-type="picture-card"
						            :file-list="fixList.videos"
						            name="file"
									:on-preview="(file) => {dlg_previewVideo.video_url = file.url;dlg_previewVideo.visible = true;}"
									:on-remove="removeVideo"
									 :on-success="uploadSuccessVideo"
						           >
						        <i class="el-icon-plus"></i>
						    </el-upload>
						</el-form-item>
				       
				    </el-col>
				</el-row>
		    </el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dlg_fix.visible = false">取 消</el-button>
		        <el-button type="primary" @click="submitOrder()" :loading="dlg_fix.btn_loading">确认</el-button>
		    </span>
		</el-dialog>
		<el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
		    <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
		</el-dialog>
   </div>
</template>
<script>
import { forEach } from 'lodash-es';
    export default {
        name: 'usercenter',
        data() {
            return {
				create_range:'',
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
				 baseUrl:this.$client.IMG_URL,
				init_data: {
				    // status_list: [{id:1, name: '进行中'},{id:0, name: '未开始'},{id:2, name: '已完成'}],
					isEnableList: [{id:0, name: '禁用'},{id:1, name: '启用'}],
					projectList:[]
				},
                //搜索
                form_search:{
                    projectId:"",
					projectName:"",
					workerName:"",
					location:"",
					searchStartForPlantStartDate:'',
					searchEndForPlantStartDate:''
					
                },
               
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        pageNo: 1,
                        pageSize: 30,
                        total: 130
                    }
                },
				dlg_fix:{
				    id:'',
				    visible:false,
				    btn_loading:false,
				    api: '',
				    title:'',
				    form:{
						icode:'',
						projectId:'',
				        projectName:'',
						workerCount:'',
						createdate:'',
						workerName:'',
						updatedate:'',
						workDays:'',
						location:'',
						description:'',
						imageIds:'',
						videoIds:'',
						constructionDate:'',
						otherCost:'',
						fuelCost:'',
				    },
				    error:{
				        projectName:'',
						
						location:'',
						workDays:'',
						constructionDate:'',
						// imageIds:'',
						videoIds:''
				    },
				    reset_form: {},
				    rules:{
				        projectName:{required: true, message: '请输入项目名称'},
						 location:{required: true, message: '请输入项目地址'},
				         imageIds:{required: true, message: '请选择项目完成图片'},
						// isEnable:{required: true, message: '请输入所需人数（输入数字）', trigger: ['change','blur']},
						workDays:{required: true, message: '请输入施工天数（输入数字,精确到半天）'},
						workerName:{required: true, message: '请输入施工人员姓名'},
						constructionDate:{required: true, message: '请选择施工日期'},
				        
				    },
				},
				fixList:{
					params: {
						headers: {
							token: localStorage.getItem('token')
						},
						data:{
							file:''
						},
						
						
					},
					hide_upload:false,
					hide_uploadV:false,
					img_list:[],
					videos:[]
				},
				dlg_preview:{
				    visible: false,
				    img_url: ''
				},
				dlg_previewVideo:{
				    visible: false,
				    video_url: ''
				}
            }
        },
        created() {
            document.title = '项目管理';
			this.getProjectList()
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
			//选择项目
			getCorpAndDept(item){
				console.log(item,"选择项目")
				this.dlg_fix.form.projectId=item.icode
				this.dlg_fix.form.projectName=item.projectName
			},
			// apk上传成功
			uploadSuccessPic(res, file, fileList){
			    this.fixList.img_list = fileList;
			    this.dlg_fix.form.imageIds = res.data.icode;
				console.log(res.data,"数据")
			    //this.dlg_appVersion.hide_upload = true;
			},
			// 删除apk
			removePic(file, fileList){
			    this.dlg_appVersion.form.fileId = '';
			    this.fixList.img_list = [];
			    this.fixList.hide_upload = false;
			},
			// video上传成功
			uploadSuccessVideo(res, file, fileList){
			    this.fixList.videos = fileList;
			    this.dlg_fix.form.videoIds = res.data.icode;
				console.log(res.data,"数据")
			    //this.dlg_appVersion.hide_upload = true;
			},
			// 删除apk
			removeVideo(file, fileList){
			    this.dlg_fix.form.videoIds= '';
			    this.fixList.videos = [];
			    this.fixList.hide_uploadV = false;
			},
			//关闭编辑或新政
			 closeGoods(){
				for(var key in this.dlg_fix.form){
					this.dlg_fix.form[key] = this.dlg_fix.reset_form[key];
				}
				this.$nextTick(()=>{
					this.$refs.formOrder.clearValidate();
			})
			},
			//编辑或新增
			handleTask(type,data){
			    this.dlg_fix.visible = true;
			    if(type == 'add'){
			        this.dlg_fix.title = '添加维修记录';
					this.fixList.videos  = [];
					this.fixList.img_list  = [];
			        this.dlg_fix.api = '/api/sys/maintenanceRecord/createForAdmin';
					
			    }else{
			        this.dlg_fix.form.icode= data.icode;
			        this.dlg_fix.title = '编辑维修记录';
			        if(data){
			            for(var key in this.dlg_fix.form){
			                this.dlg_fix.form[key] = data[key];
			            }
						if(data.imageIds){
							this.fixList.img_list  = [];
							
							var arrayPic=data.imageIds.split(',')
							arrayPic.forEach((item,index)=>{
							this.fixList.img_list.push({url: this.baseUrl +'/api/sys/file/download?attachId='+ item}) 
								
							})
							console.log(this.fixList.img_list,"图片")
							this.fixList.hide_upload = true;
						}else{
							this.fixList.img_list  = [];
							this.fixList.hide_upload = false;
						}
						if(data.videoIds){
							this.fixList.videos = [{url: this.baseUrl +'/api/sys/file/download?attachId='+ data.videoIds}];
							console.log(this.fixList.img_list,"图片")
							this.fixList.hide_uploadV = true;
						}else{
							this.fixList.videos  = [];
							this.fixList.hide_uploadV = false;
						}
						
					}
					this.dlg_fix.api = '/api/sys/maintenanceRecord/updateForAdmin';
			    }
			},
			//提交项目信息
			submitOrder(){
			    var _this = this;
			    _this.$refs['formOrder'].validate((valid) => {
			        if (valid) {
			            this.dlg_fix.btn_loading = true;
			            this.$client.post(this.dlg_fix.api, this.dlg_fix.form, function(res,message){
			                //console.log(res)
			                _this.$message(message);
			                _this.getList();
			                _this.dlg_fix.btn_loading = false;
			                _this.dlg_fix.visible = false;
			            }, function(message){
			                _this.dlg_fix.btn_loading = false;
			                if((typeof message)==='object'){
			                    for(var key in message){
			                        _this.dlg_fix.error[key] = message[key];
			                    }
			                }
			            });
			        } else {
			            console.log('error submit!!');
			    return false;
			}
			});
			},
			//获取项目列表
			getProjectList() {
			    var _this = this;
			    
			    _this.table_data.loading = true;
			    // var status_list = [{id:-1, name: '全部'}];
			    this.$client.get('/api/sys/maintenanceProject/getList', {}, function(res,message,total,totalPages){
					console.log("热水",res,total)
			        _this.init_data.projectList = res;
			        // _this.table_data.page_info.total = total;
					 // _this.table_data.page_info.total = total;
			        _this.table_data.loading = false;
			    },function(res){
			        _this.table_data.loading = false;
			    });
			},
			//获取维修记录列表
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.pageNo = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                // var status_list = [{id:-1, name: '全部'}];
                this.$client.get('/api/sys/maintenanceRecord/getList', params, function(res,message,total,totalPages){
					// console.log("热水",res,total)
                    _this.table_data.list = res;
                    _this.table_data.page_info.total = total;
					 // _this.table_data.page_info.total = total;
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
			//删除项目
			deleteTask(id){
			    var _this = this;
			    this.$confirm('确定要删除？', "", {
			                confirmButtonText: "确定",
			                cancelButtonText: "取消",
			                iconClass:"icon-delete el-icon-delete",
			                customClass:"my-confirm-box",
			                center: true,
			            })
			            .then(() => {
			        _this.$client.post('/api/sys/maintenanceRecord/remove', {id:id}, function(res,message){
			        _this.getList();
			    },function(res){
			
			    });
			})
			.catch(() => {});
			},
			exreport(){
				window.open(this.baseUrl + '/api/sys/maintenanceRecord/export?projectId='+this.form_search.projectId+'&projectName='+this.form_search.projectName+'&workerName='+this.form_search.workerName+'&location='+this.form_search.location+'&constructionStartDate='+this.form_search.searchStartForPlantStartDate+'&constructionEndDate='+this.form_search.searchEndForPlantStartDate+'&token='+localStorage.getItem('token'))
			},
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            },
			create_range(newVal) {
				if (newVal == null) {
					this.form_search.searchStartForPlantStartDate = '';
					this.form_search.searchEndForPlantStartDate = '';
				} else {
					this.form_search.searchStartForPlantStartDate = newVal[0];
					this.form_search.searchEndForPlantStartDate = newVal[1];
				}
			},
        }
    }
</script>
<style>

</style>
<style scoped>

</style>